import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface FrameSelectIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const FrameSelectIcon = ({ className, ...props }: FrameSelectIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.9984 2H2V4.9984H4.9984V2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M4.99854 3.50098H18.9987"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M3.5 4.99854V19.0005"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M20.4978 5V19.002"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M4.99854 20.501H18.9987"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M4.9984 19H2V21.9984H4.9984V19Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M21.9974 2.00195H18.999V5.00035H21.9974V2.00195Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M21.9974 19.002H18.999V22.0004H21.9974V19.002Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      strokeWidth="1.5"
    />
    <path
      d="M12.3076 9.79289L13.3076 8.79289C13.7455 8.35499 14.4555 8.35499 14.8934 8.79289C15.3313 9.23079 15.3313 9.94078 14.8934 10.3787L13.8934 11.3787M12.3076 9.79289L9.31652 12.784C9.16661 12.9339 9.06823 13.1275 9.03557 13.337L8.79288 14.8934L10.3492 14.6508C10.5587 14.6181 10.7523 14.5197 10.9023 14.3698L13.8934 11.3787M12.3076 9.79289L13.8934 11.3787"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default FrameSelectIcon;
